// extracted by mini-css-extract-plugin
export var container = "banner-slider-module--container--XjeD1";
export var container1 = "banner-slider-module--container1--Z3bhf";
export var font_mob = "banner-slider-module--font_mob--HXeLn";
export var sliderHeight = "banner-slider-module--sliderHeight--54x6D";